import { IonAccordion, IonAccordionGroup, IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSkeletonText, IonSpinner, IonText, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { add, addCircleOutline, addOutline, alarmOutline, informationCircle, locationOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const Places: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);    
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const router = useIonRouter();

    const { networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, setShowLoader, limits, profiles, settings, timezones, timezoneName, getTimezones, timezonesIANA, getTimezonesIANA, timezoneIANAName, savedPlaces, getSavedPlaces, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo, textLogoLoaded, fadeInTextLogo } = useAppContext();
    
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {   
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else { 
                const authenticated = await authenticateMember();         
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            }
        };
        authenticate();
    }); 
    

    useEffect(() => {
        if (limits.places > 0) {
            const fetchData = async () => {
                if(timezonesIANA.length === 0) await getTimezonesIANA();
                await getSavedPlaces(authorizedMember.memberToken, limits.places);
                window.setTimeout(() => {
                    setShowLoader(false);
                }, 1500);
            }
            fetchData();
        }
    }, [authorizedMember, limits]);
    

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        //setLoading(true);
        setTimeout(async () => {
            await getSavedPlaces(authKey.mt, limits.places);
            event.detail.complete();
            //setLoading(false);
        }, 2000);
    };

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={locationOutline}></IonIcon> My Places<br /><span>Manage your saved locations</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                           {profiles?.places < limits?.places &&
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/place/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Add a new Place</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Place?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                    <p>A <strong>SoloWise Place</strong> is a saved location that represents where you plan to be, or where a Route begins or ends. It adds a reference point to your Timers and helps responders orient to your location if an alert is triggered.</p>
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>

                {savedPlaces?.length > 0
                    ? <>
                        {savedPlaces
                            .filter((p: any) => p.placeSaved == '1')
                            .map((place: any, index: any) => (                    
                                <IonCard key={index} routerDirection='forward' routerLink={`/account/place/edit/${place.placeToken}`}>
                                    <IonCardHeader>                                        
                                        <IonCardTitle>{place.placeName}</IonCardTitle>
                                        <IonCardSubtitle>
                                            {place.placeLocation == '' 
                                                ? <>Location is not recorded</> 
                                                : <>{place.placeLocation}</>
                                            }
                                        </IonCardSubtitle>
                                        <IonCardSubtitle>
                                            {place.placeTimezone == '' 
                                                ? <>Timezone is not recorded</>
                                                : <>{timezoneIANAName(place.placeIANATimezone)} Time</>
                                            } 
                                        </IonCardSubtitle>
                                    </IonCardHeader> 
                                </IonCard>
                        ))}

                        {profiles?.places >= limits?.places &&
                            <IonCard>
                                <IonCardHeader>
                                    <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                        You've reached the limit of Places for your current plan.
                                    </IonCardTitle>
                                </IonCardHeader>
                                <IonCardContent>
                                    <p className='ion-margin-bottom ion-text-center'>
                                        You can add more Places by upgrading to a SoloWise Premium plan. 
                                    </p>
                                    <p className='ion-margin-bottom ion-text-center'>                            
                                        <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                                    </p>
                                </IonCardContent>
                            </IonCard>
                        }   
                      </>

                    : <p className='ion-text-center'>You have no recorded Places.</p>
                }
            </IonContent>
        </IonPage>
    );
};

export default Places;